import { styled } from 'styled-components'
import { Typography } from 'antd'
import { ComponentProps } from 'react'

export const Title = styled(Typography.Text)<
  ComponentProps<typeof Typography.Text> & {
    $level: 1 | 2 | 3 | 4 | 5 | 6
    $color?: string
    $textAlign?: 'left' | 'center' | 'right'
    $hoverColor?: string
  }
>`
  && {
    font-size: ${(props) => {
      switch (props.$level) {
        case 1:
          return '66px'
        case 2:
          return '53px'
        case 3:
          return '39px'
        case 4:
          return '24px'
        case 5:
          return '20px'
        case 6:
          return '16px'
      }
    }};
    font-weight: ${(props) => {
      switch (props.$level) {
        case 1:
        case 2:
        case 6:
          return '700'
        case 3:
        case 4:
        case 5:
          return '600'
      }
    }};
    letter-spacing: 0;
    line-height: ${(props) => {
      switch (props.$level) {
        case 1:
          return '78px'
        case 2:
          return '66px'
        case 3:
          return '45px'
        case 4:
          return '38px'
        case 5:
          return '28px'
        case 6:
          return '22px'
      }
    }};
    ${(props) => (props.$color ? `color: ${props.$color};` : '')}
    ${(props) => (props.$textAlign ? `text-align: ${props.$textAlign};` : '')}

    &:hover {
      ${(props) => (props.$hoverColor ? `color: ${props.$hoverColor};` : '')}
    }
  }
`

export const Body = styled(Typography.Text)<
  ComponentProps<typeof Typography.Text> & {
    $size?: 'large' | 'medium' | 'small' | 'xSmall'
    $fontWeight?: 'bold' | 'semiBold' | 'regular'
    $fontSize?: string
    $color?: string
    $textAlign?: 'left' | 'center' | 'right'
  }
>`
  && {
    font-size: ${(props) => {
      if (props.$fontSize) {
        return props.$fontSize
      }
      switch (props.$size) {
        case 'large':
          return '24px'
        case 'medium':
          return '21px'
        case 'small':
        default:
          return '18px'
      }
    }};
    font-weight: ${(props) => {
      switch (props.$fontWeight) {
        case 'bold':
          return '700'
        case 'semiBold':
          return '600'
        case 'regular':
        default:
          return '400'
      }
    }};
    letter-spacing: 0;
    line-height: ${(props) => {
      switch (props.$size) {
        case 'large':
          return '38px'
        case 'medium':
          return '35px'
        case 'small':
        default:
          return '32px'
      }
    }};
    ${(props) => (props.$color ? `color: ${props.$color};` : '')}
    ${(props) => (props.$textAlign ? `text-align: ${props.$textAlign};` : '')}
    };
  }
`
